import type { ReactElement } from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ViewportArrowProps {
  direction: 'left' | 'right'
  onClick: () => void
  className?: string
}

export function ViewportArrow({ direction, onClick, className }: ViewportArrowProps): ReactElement {
  const Icon = direction === 'left' ? ChevronLeft : ChevronRight

  return (
    <div
      className={cn(
        'sticky top-1/2 z-20 h-0',
        direction === 'left' ? 'float-left -ml-11' : 'float-right -mr-11',
        className,
      )}
    >
      <button
        type="button"
        onClick={onClick}
        className={cn(
          '-translate-y-1/2',
          'flex h-10 w-10 items-center justify-center rounded-full',
          'bg-card/80 backdrop-blur border border-border shadow-md',
          'text-muted-foreground hover:text-foreground hover:bg-card',
          'transition-all hover:scale-105',
        )}
        aria-label={direction === 'left' ? 'Navigate left' : 'Navigate right'}
      >
        <Icon className="h-5 w-5" />
      </button>
    </div>
  )
}
